import { useDocumentTableQuery } from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export interface IData {
  id: string;
  fileName: string;
  size: string;
  updatedDate: DateTime;
  createdDate: DateTime;
  uploadedBy: string;
}

export function useQuery(projectId: string) {
  const tuple = useDocumentTableQuery({
    variables: {
      projectId
    },
    skip: projectId === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.project?.documents.map((node) => ({
        id: node.id,
        createdDate: node.createdTimestamp,
        updatedDate: node.updatedTimestamp,
        fileName: node.title
          ? node.title
          : node.apiFile.fileName,
        size: node.apiFile.formattedFileSize,
        uploadedBy: node.uploadedBy?.fullName
        ?? ''
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
